import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { GlobalsService } from '../../../../core/services/globals.service';
import {
  PostRequestBase,
  ResponseBase,
  ScreenModel,
} from '../../../../core/models/common';
import { ApiService } from '../../../../core/services/api-mock.service';

export interface ChangePasswordRequestData extends PostRequestBase {
  NewPassword: string;
}

export interface ChangePasswordResponseData extends ResponseBase {}

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
  @Output() handleChangePasswordSubmit = new EventEmitter<string>();
  changePasswordForm: FormGroup = this.formBuilder.group({
    newPassword: [
      '',
      [Validators.required, Validators.minLength(8), Validators.maxLength(64)],
    ],
    confirmPassword: [
      '',
      [Validators.required, Validators.minLength(8), Validators.maxLength(64)],
    ],
  });

  constructor(
    private formBuilder: FormBuilder,
    public globals: GlobalsService,
  ) {}

  ngOnInit(): void {
    console.log('[ModalBodyComponent] Modal OnInit');
  }

  get hasSpecialCharacter(): boolean {
    //https://www.regextester.com/99810
    const specialCharactersReg = /[`~!@#$%^&*()_+={}[\]|:";'<>?./]/g;
    return specialCharactersReg.test(this.newPasswordControl.value);
  }

  get isAtLeast8Characters(): boolean {
    return this.newPasswordControl.value.length >= 8;
  }

  get hasNumber(): boolean {
    const numberReg = /\d/;
    return numberReg.test(this.newPasswordControl.value);
  }

  get isPasswordMatch(): boolean {
    return this.newPasswordControl.value === this.confirmPasswordControl.value;
  }

  get newPasswordControl() {
    return this.changePasswordForm.get('newPassword') as FormControl;
  }

  get confirmPasswordControl() {
    return this.changePasswordForm.get('confirmPassword') as FormControl;
  }

  async onChangePassword() {
    if (
      this.newPasswordControl.dirty &&
      !(
        this.isAtLeast8Characters &&
        this.hasSpecialCharacter &&
        this.hasNumber &&
        this.isPasswordMatch
      )
    ) {
      return;
    }

    this.handleChangePasswordSubmit.emit(this.newPasswordControl.value);
  }
}
